export default __webpack_public_path__ + "static/media/delete_trash.71ba0d20.svg";